import { createContext, type PropsWithChildren, useContext } from 'react';

type ModalContextValue = () => void;

const ModalContext = createContext<ModalContextValue | null>(null);

export function ModalProvider(
  props: PropsWithChildren<{ value: ModalContextValue }>
) {
  return <ModalContext.Provider {...props} />;
}

export function useModalConext() {
  const modalContextValue = useContext(ModalContext);
  if (modalContextValue === null) {
    throw new Error('must use ModalContext within <ModalProvider />');
  }

  return modalContextValue;
}
